
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import auditMadel from "./audit-madel.vue";
import { getPurchasedRecordsList } from "@/api/api-basic-sms";
import { getOptionList, optionKey } from "@/api/api-dict";
import PiExport from "@/components/pi-export/pi-export.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-export": PiExport,
    "pi-audit-madel": auditMadel
  }
})
export default class PurchaseRecord extends Vue {
  private purchaseList: object[] = [];
  private orderStatusList: object[] = [];

  private total = 0;
  private loading = false;

  private auditMadel: objAny = {};
  private formInline: objAny = {
    agent: 1,
    beginTime: "",
    endTime: "",
    auditStatus: "",
    number: "",
    oprName: "",
    pkid: "",
    purchasedWay: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };

  private time: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("messageRecord.pkid"),
      key: "pkid",
      minWidth: 120
    },
    {
      title: i18n.t("oprName"),
      key: "oprName",
      minWidth: 120
    },
    {
      title: i18n.t("messageRecord.createUserName"),
      key: "createUserName",
      minWidth: 100
    },
    {
      title: i18n.t("messageRecord.purchasedCount"),
      key: "purchasedCount",
      minWidth: 120
    },
    {
      title: i18n.t("messageRecord.paymentAmount"),
      key: "paymentAmount",
      minWidth: 120
    },
    {
      title: i18n.t("messageRecord.purchasedWay"),
      key: "purchasedWayDesc",
      minWidth: 100
    },
    {
      title: i18n.t("messageRecord.auditStatus"),
      key: "auditStatusDesc",
      minWidth: 100
    },
    {
      title: i18n.t("messageRecord.createTime"),
      key: "createTime",
      minWidth: 140
    },
    {
      title: i18n.t("remark"),
      key: "remark",
      minWidth: 120
    },
    {
      title: i18n.t("operation"),
      key: "action",
      width: 120,
      slot: "action"
    }
  ];
  public routerQuery(oprName: string): void {
    this.formInline.oprName = oprName;
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getPurchasedRecordsList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
  }
  private timeFn(val: objAny): void {
    if (val[0] !== "" && val[1] !== "") {
      this.formInline.beginTime = val[0];
      this.formInline.endTime = val[1];
    } else {
      this.formInline.beginTime = "";
      this.formInline.endTime = "";
    }
  }
  public auditClick(item: objAny) {
    this.auditMadel.open(item);
  }
  async getOptionList() {
    const ret = await getOptionList([
      optionKey.smsAuditStatusObj,
      optionKey.purchasedWayObj
    ]); //请求字典
    this.orderStatusList = ret[optionKey.smsAuditStatusObj];
    this.purchaseList = ret[optionKey.purchasedWayObj];
  }
  mounted() {
    this.getOptionList();
    const startTime = this.$common.thisTimes("yyyy-MM") + "-01";
    const time = this.$common.thisTimes("yyyy-MM-dd");
    this.time = [startTime, time];
    this.formInline.beginTime = startTime;
    this.formInline.endTime = time;
    // this.getTableList();
    this.$nextTick(() => {
      this.auditMadel = this.$refs.auditMadel;
    });
  }
  activated() {
    const query = this.$route.query;
    if (query.auditStatus) {
      this.formInline.globalPageIndex = 1;
      this.formInline.auditStatus = query.auditStatus;
      this.getTableList();
    } else {
      if (this.tableList.length == 0) {
        this.getTableList();
      }
    }
  }
}
